import React from 'react';
import { FormData, FormErrors, OrderType } from '../../hooks/useCheckoutForm';
import { PickupForm } from './PickupForm';

interface CheckoutFormProps {
  formData: FormData;
  errors: FormErrors;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onTakeoutOrder: () => void;
  orderLoading: boolean;
  cartItemsCount: number;
  showPayNow?: boolean;
  showPayLater?: boolean;
  activeTab: OrderType;
}

export const CheckoutForm: React.FC<CheckoutFormProps> = ({
  formData,
  errors,
  handleChange,
  onSubmit,
  onTakeoutOrder,
  orderLoading,
  cartItemsCount,
  showPayNow = true,
  showPayLater = true,
  activeTab,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <PickupForm
        formData={formData}
        errors={errors}
        handleChange={handleChange}
        onSubmit={onSubmit}
        onTakeoutOrder={onTakeoutOrder}
        orderLoading={orderLoading}
        cartItemsCount={cartItemsCount}
        showPayNow={showPayNow}
        showPayLater={showPayLater}
      />
    </div>
  );
};
